// export const graphqlUrl = "https://devapi.movingshortly.com/v1alpha1/graphql";

// export const subscriptionUrl =
//   "wss://devapi.movingshortly.com/v1alpha1/graphql";

export const graphqlUrl = "https://api.movingshortly.com/v1alpha1/graphql";

export const subscriptionUrl = "wss://api.movingshortly.com/v1alpha1/graphql";
